import React, { useRef, useState } from "react";
import "./style.scss";

import CheckSolidGreenIcon from "../../../assets/icons/check-solid-green.svg";

import { validateEmail } from "../../../utils/helpers/string";
import Tooltip from "../../../reusableComponents/Tooltip";
import axios from "axios";
import { returnMessages } from "../../../store/reducers/message";
import { useDispatch } from "react-redux";
import { returnErrors } from "../../../store/reducers/error";
import Spinner from "../../../reusableComponents/Spinner";
import { baseUrl } from "../../../utils/apis";
import { useFormik } from "formik";
import * as Yup from "yup";


function ForgotPasswordForm() {
  const [isSpinner, setIsSpinner] = useState(false);
  const emailRef = useRef(null);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("The email entered is wrong!")
        .required("Please enter the email!")
        .test(
          'is-lowercase',
          'Email must be in lowercase.',
          value => !value || value === value.toLowerCase()
        ),
    }),
    onSubmit: async (values) => {
      setIsSpinner(true);
      try {
        const formData = new FormData();
        formData.append("email", values.email);
        const res = await axios.post(`${baseUrl}/auth/reset-password/`, formData);
        if (res.status === 200) {
          const msg = `An email has been sent to ${values.email} with instructions for resetting your password.`;
          const status = res.status;
          dispatch(returnMessages(msg, status));
        } else {
          const msg = res.response?.data?.detail || `Please check the email!`;
          const status = 500;
          dispatch(returnErrors(msg, status));
        }
      } catch (err) {
        let errorMsg = "Something went wrong. Please try again later.";
        const statusCode = err.response?.status;
        if (statusCode && statusCode >= 500) {
          errorMsg = "Something went wrong. Please try again later.";
        } else if (err.response && err.response.data) {
          const data = err.response.data;
          if (typeof data === "string") {
            errorMsg = data;
          } else if (data.detail) {
            errorMsg = data.detail;
          } else if (data.error) {
            errorMsg = data.error;
          } else if (typeof data === "object") {
            const keys = Object.keys(data);
            if (keys.length > 0) {
              const firstVal = data[keys[0]];
              if (Array.isArray(firstVal) && firstVal.length > 0) {
                errorMsg = firstVal[0];
              } else if (typeof firstVal === "string") {
                errorMsg = firstVal;
              }
            }
          }
        } else if (err.message) {
          errorMsg = err.message === "Request failed with status code 400"
            ? "Invalid email or request. Please try again."
            : err.message;
        }
        dispatch(returnErrors(errorMsg, statusCode || 500));
      } finally {
        setIsSpinner(false);
      }
    },
  });

  return (
    <div className="forgotpasswordform-container">
      <div className="forgotpasswordform-subcontainer">
 
        <form
          className="forgotpasswordform-innercontainer forgotpasswordform-container_form"
          onSubmit={formik.handleSubmit}
        >
          <div className="forgotpasswordform-subcontainer_form">
            <div
              ref={emailRef}
              className="forgotpasswordform-innercontainer_form"
            >
              <div className="title">
                {" "}
                <h2>Email</h2>
              </div>

              <div className="forgotpasswordform-container_input">
         
                <input
                  type="text"
                  name="email"
                  id="email"
                  className="forgotpasswordform-input inputDiv"
                  value={formik.values.email}
                  onChange={(e) => {
                    e.target.value = e.target.value.toLowerCase();
                    formik.handleChange(e);
                  }}
                  onBlur={(e) => {
                    e.target.value = e.target.value.toLowerCase();
                    formik.handleBlur(e);
                  }}
                  placeholder="Email Address"
                />
                {validateEmail(formik.values.email) && !formik.errors.email && (
                  <img
                    src={CheckSolidGreenIcon}
                    alt=""
                    className="forgotpasswordform-icon_emailVerify"
                  />
                )}
              </div>
            </div>  
           {formik.errors.email&& <p style={{color:"#ff3333"}}>
              {formik.touched.email && formik.errors.email}
            </p>}
          </div>
          <div className="forgotpasswordform-container_button">
            <button
              className="forgotpasswordform-button submit_button"
              type="submit"
              disabled={isSpinner}
            >
              {isSpinner ? <Spinner /> : "Confirm"}
           
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPasswordForm;
